import React, { useState, useContext, useEffect } from "react";
import { Menu, Button, Dropdown, Space, Form, DatePicker, Select, Input, Row, Col } from "antd";
import ColaboradorService from "services/ColaboradorService";
import SeccionService from "services/SeccionService";
import { filtroEstadoAprobacionAtom, openDrawerImportarAusenciasMasivasAtom, solicitudesAusenciaAtom } from "../../consultaSolicitudesStore";
import { useAtom } from "jotai";
import { SolicitudAusenciaService } from "services";
import { SecurityContext } from "context/SecurityContextProvider";
import {
    paginaActualAtom,
    tamanioPaginadoAtom,
    totalRegistrosAtom,
    filtroColaboradorAtom,
    filtroFechaInicioAtom,
    filtroFechaFinAtom,
    filtroEstadoAtom,
    filtroEstadoJefeInmediatoAtom,
    filtroTipoAusenciaAtom,
    filtroEstadoOtrosCargosAtom,
    visibleModalCrearSolicitudAtom,
    loadingExportarAtom,
    filtroPerfilAtom,
    filtroSeccionAtom,
} from "../../consultaSolicitudesStore";
import { EstadoSolicitudAusencia } from "enums/EstadoSolicitudAusencia";
import { usePaginacion, useListarTipoAusencia } from "../../hooks";
import { useGenerarReporteExcelSolicitudesAusencia } from "../../hooks";
import useGenerarReporteExcelPCA from "../../hooks/useGenerarReporteExcelPCA";
import { PlusOutlined, FileExcelOutlined, FileTextOutlined, CaretDownOutlined } from "@ant-design/icons";
import { OpcionService } from "services";
import { OPCIONES } from "enums";

const FiltroConsultaSolicitudes = () => {
    const [colaboradores, setColaboradores] = useState(undefined);
    const [colaboradorSeleccionado, setColaboradorSeleccionado] = useState(undefined);
    const [secciones, setSecciones] = useState([]);
    const [, setFiltroSeccion] = useAtom(filtroSeccionAtom);
    const [solicitudesAusencia, setSolicitudesAusencia] = useAtom(solicitudesAusenciaAtom);
    const [filtroColaborador, setfiltroColaborador] = useAtom(filtroColaboradorAtom);
    const [filtroFechaInicio, setFiltroFechaInicio] = useAtom(filtroFechaInicioAtom);
    const [filtroFechaFin, setFiltroFechaFin] = useAtom(filtroFechaFinAtom);
    const [filtroEstado, setFiltroEstado] = useAtom(filtroEstadoAtom);
    const [filtroEstadoAprobacion, setFiltroEstadoAprobacion] = useAtom(filtroEstadoAprobacionAtom);
    const [filtroEstadoJefeInmediato, setFiltroEstadoJefeInmediato] = useAtom(filtroEstadoJefeInmediatoAtom);
    const { getUsuarioAutenticado } = useContext(SecurityContext);
    const [paginaActual, setPaginaActual] = useAtom(paginaActualAtom);
    const [tamanioPaginado] = useAtom(tamanioPaginadoAtom);
    const [, setTotalRegistros] = useAtom(totalRegistrosAtom);
    const [mesInicio, setMesInicio] = useState(null);
    const [mesFin, setMesFin] = useState(null);
    const { tiposAusencia } = useListarTipoAusencia();
    const [, setFiltroTipoAusencia] = useAtom(filtroTipoAusenciaAtom);
    const [filtroEstadoOtrosCargos, setFiltroEstadoOtrosCargos] = useAtom(filtroEstadoOtrosCargosAtom);
    const [, setOpenDrawerImportarAusenciasMasivas] = useAtom(openDrawerImportarAusenciasMasivasAtom);
    const [loadingExportar, setLoadingExportar] = useAtom(loadingExportarAtom);
    const [, setFiltroPerfil] = useAtom(filtroPerfilAtom);

    //const {onFiltrar}=usePaginacion();

    const [formFiltro] = Form.useForm();
    const { RangePicker } = DatePicker;

    const { generarReporteSolicitudes } = useGenerarReporteExcelSolicitudesAusencia();
    const { generarReportePCA, loadingPCA } = useGenerarReporteExcelPCA();
    const [, setVisibleModalCrearSolicitud] = useAtom(visibleModalCrearSolicitudAtom);

    const [codigosOpciones, setCodigosOpciones] = useState([]);

    const isSDF = getUsuarioAutenticado().empresaSeleccionada?.ruc === "20330791684" ? true : false;
    const isSDFEnergia = getUsuarioAutenticado().empresaSeleccionada?.ruc === "20512436090" ? true : false;

    useEffect(() => {

        const cargaInicial = async () => {
            const codigosOpciones = await OpcionService.listar(getUsuarioAutenticado().id);
            setCodigosOpciones(codigosOpciones);
            const lstSecciones = await SeccionService.listar(getUsuarioAutenticado().empresaSeleccionada.id);
            setSecciones(lstSecciones);
        }
        cargaInicial();
    }, []);

    const onSearchColaboradores = async (value) => {
        if (value === "") {
            setColaboradores([]);
            return;
        }
        const respuesta = await ColaboradorService.listarPorNombreCompletoODni({
            filtro: value.trim(),
        });
        setColaboradores(respuesta.colaboradores);
    };

    const onSelectColaborador = (value, option) => {
        console.log("colaboradorSeleccionado", option.key);
        setColaboradorSeleccionado(option.key);
        setfiltroColaborador(option.value);
    };

    const onChangeColaborador = (value) => {
        console.log("colaboradorSeleccionado", value);
        setfiltroColaborador(value);
    };

    const onChangeMeses = (value) => {
        const mesInicio = value != null ? value[0].format("01/MM/YYYY") : null;
        const mesFin = value != null ? value[1].daysInMonth() + value[1].format("/MM/YYYY") : null;
        setMesInicio(mesInicio);
        setMesFin(mesFin);
        setFiltroFechaInicio(mesInicio);
        setFiltroFechaFin(mesFin);
        formFiltro.setFieldsValue({ dias: null });
    };

    const onChangeRangoDias = (value) => {
        const diaInicio = value != null ? value[0].format("DD/MM/YYYY") : null;
        const diaFin = value != null ? value[1].format("DD/MM/YYYY") : null;
        setFiltroFechaInicio(diaInicio);
        setFiltroFechaFin(diaFin);
        formFiltro.setFieldsValue({ meses: null });
        setMesInicio(null);
        setMesFin(null);
    };

    const onChangeSeccion = (value) => {
        setFiltroSeccion(value);
    };

    const onChangeEstado = (value) => {
        setFiltroEstado(value);
    };

    const onChangeEstadoJefeInmediato = (value) => {
        setFiltroEstadoJefeInmediato(value);
    };

    const onChangeTipoAusencia = (value) => {
        setFiltroTipoAusencia(value);
    };

    const onChangeEstadoOtrosCargos = (value) => {
        setFiltroEstadoOtrosCargos(value);
    };

    const onChangeEstadoAprobacion = (value) => {
        setFiltroEstadoAprobacion(value);
    };

    const onChangePerfil = (value) => {
        setFiltroPerfil(value);
    };

    const onClickExportarSolicitudes = () => {
        generarReporteSolicitudes();
    };

    const onClickBtnImportar = (e) => {
        if (e.key === "importar-ausencias-masivas") {
            setOpenDrawerImportarAusenciasMasivas(true);
        }
    }

    return (
        <div>
            <div style={{ textAlign: "end" }}>
                <Space>
                    {codigosOpciones && codigosOpciones.includes(OPCIONES.PAGINA_VACACIONES_SEGUIMIENTO_SOLICITUDES.BOTON_CREAR_SOLICITUD) && (
                        <Button type="primary" onClick={() => setVisibleModalCrearSolicitud(true)} icon={<PlusOutlined />}>
                            Crear Solicitud
                        </Button>
                    )}
                    {codigosOpciones && codigosOpciones.includes(OPCIONES.PAGINA_VACACIONES_SEGUIMIENTO_SOLICITUDES.BOTON_EXPORTAR_SOLICITUDES) && (
                        <Button type="primary" onClick={onClickExportarSolicitudes} loading={loadingExportar}>
                            Exportar Solicitudes
                        </Button>
                    )}
                    {(isSDF || isSDFEnergia) && (
                        <Dropdown
                            menu={{
                                items: [
                                    { key: "xlsx", label: "Excel (.xlsx)", icon: <FileExcelOutlined /> },
                                    { key: "csv", label: "CSV (.csv)", icon: <FileTextOutlined /> },
                                ],
                                onClick: ({ key }) => generarReportePCA(key),
                            }}
                        >
                            <Button type="primary" icon={<FileExcelOutlined />} loading={loadingPCA}>
                                Exportar PCA <CaretDownOutlined />
                            </Button>
                        </Dropdown>
                    )}

                    <Dropdown.Button
                        menu={{
                            items: [
                                {
                                    label: (isSDF || isSDFEnergia) ? "Movimientos Masivos" :"Ausencias Masivas",
                                    key: "importar-ausencias-masivas",
                                    icon: <FileExcelOutlined style={{ fontSize: "18px" }} />,
                                },
                            ],
                            onClick: onClickBtnImportar,
                        }}
                        icon={<CaretDownOutlined />}
                        trigger={["click"]}
                        arrow
                    >
                        Importar
                    </Dropdown.Button>

                </Space>
            </div>
            <Form
                layout="vertical"
                form={formFiltro}
                initialValues={{
                    estadoAprobacion: EstadoSolicitudAusencia.APROBADO,
                }}
            >
                <Row gutter={16}>
                    <Col>
                        <Form.Item label={(isSDF || isSDFEnergia) ? "Tipo Movimiento":"Tipo Ausencia"} name="tipoAusencia">
                            <Select
                                style={{ width: "250px" }}
                                placeholder="Seleccione el Tipo ausencia"
                                onChange={onChangeTipoAusencia}
                                allowClear
                            >
                                {tiposAusencia !== undefined &&
                                    tiposAusencia.map((tipo) => (
                                        <Select.Option key={tipo.id} value={tipo.id}>
                                            {tipo.descripcion}
                                        </Select.Option>
                                    ))}
                                <Select.Option value="TODOS">TODOS</Select.Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col>
                        <Form.Item label="Colaborador" name="colaborador">
                            <Select
                                style={{ width: "250px" }}
                                allowClear
                                showSearch
                                placeholder="Ingrese el nombre del colaborador"
                                onSearch={onSearchColaboradores}
                                filterOption={(input, option) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                                //onSelect={onSelectColaborador}
                                onChange={onChangeColaborador}
                            >
                                {colaboradores !== undefined &&
                                    colaboradores?.map((colaborador) => (
                                        <Select.Option
                                            key={colaborador.numeroDocumentoIdentidad}
                                            value={colaborador.numeroDocumentoIdentidad}
                                        >
                                            {colaborador.nombreCompleto}
                                        </Select.Option>
                                    ))}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col>
                        <Form.Item label="Por meses" name="meses">
                            <RangePicker picker="month" format={"MM/YYYY"} onChange={onChangeMeses} />
                        </Form.Item>
                    </Col>
                    {(isSDF || isSDFEnergia) && (
                        <Col>
                            <Form.Item label="Por rango de días" name="dias">
                                <RangePicker format={"DD/MM/YYYY"} onChange={onChangeRangoDias} />
                            </Form.Item>
                        </Col>
                    )}
                    {/* Área - pendiente de pruebas
                    {isSDF && (
                        <Col>
                            <Form.Item label="Área" name="seccion">
                                <Select
                                    style={{ width: "200px" }}
                                    placeholder="Seleccione el área"
                                    onChange={onChangeSeccion}
                                    allowClear
                                    showSearch
                                    filterOption={(input, option) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                >
                                    {secciones.length > 0 &&
                                        secciones.map((seccion) => (
                                            <Select.Option key={seccion.id} value={seccion.id}>
                                                {seccion.nombre}
                                            </Select.Option>
                                        ))}
                                </Select>
                            </Form.Item>
                        </Col>
                    )}
                    */}
                    {(isSDF || isSDFEnergia) && (
                        <Col>
                            <Form.Item label="Perfil" name="perfil">
                                <Select
                                    style={{ width: "105px" }}
                                    placeholder="Seleccione el perfil"
                                    onChange={onChangePerfil}
                                    allowClear
                                >
                                    <Select.Option value="TODOS">TODOS</Select.Option>
                                    <Select.Option value="EMPLEADO">EMPLEADO</Select.Option>
                                    <Select.Option value="OBRERO">OBRERO</Select.Option>
                                    <Select.Option value="GERENTE">GERENTE</Select.Option>
                                    <Select.Option value="PRACTICANTE">PRACTICANTE</Select.Option>
                                </Select>
                            </Form.Item>
                        </Col>
                    )}
                    <Col>
                        <Form.Item label="Estado Aprobación" name="estadoAprobacion">
                            <Select
                                style={{ width: "250px" }}
                                placeholder="Seleccione el estado de aprobación"
                                onChange={onChangeEstadoAprobacion}
                                allowClear
                            >
                                <Select.Option value="TODOS">TODOS</Select.Option>
                                <Select.Option value={EstadoSolicitudAusencia.PENDIENTE}>
                                    {EstadoSolicitudAusencia.PENDIENTE}
                                </Select.Option>
                                <Select.Option value={EstadoSolicitudAusencia.APROBADO}>
                                    {EstadoSolicitudAusencia.APROBADO}
                                </Select.Option>
                                <Select.Option value={EstadoSolicitudAusencia.RECHAZADO}>
                                    {EstadoSolicitudAusencia.RECHAZADO}
                                </Select.Option>
                            </Select>
                        </Form.Item>
                    </Col>

                </Row>
            </Form>
        </div>
    );
};
export default FiltroConsultaSolicitudes;
